import { render, staticRenderFns } from "./ServiceDataMigration.vue?vue&type=template&id=80841974&scoped=true&"
import script from "./ServiceDataMigration.vue?vue&type=script&lang=js&"
export * from "./ServiceDataMigration.vue?vue&type=script&lang=js&"
import style0 from "./ServiceDataMigration.vue?vue&type=style&index=0&id=80841974&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80841974",
  null
  
)

export default component.exports